import { HttpContextToken } from '@angular/common/http';

export const SKIP_ERROR_MODAL = new HttpContextToken<boolean>(() => false);
